import { combineReducers } from 'redux';

import authentication from './authentication';
import loading from './loading';
import snackbar from './snackbar';
import users from './users';
import series from './series';

export default combineReducers({
  authentication,
  loading,
  snackbar,
  series,
  users,
});
